import PropTypes from "prop-types";

import Block from "components/Layout/Block";

import styles from "./Checkbox.module.scss";

const Checkbox = ({ name, register, error = false, children }) => {
  return (
    <>
      <label className={styles.checkbox}>
        <input type="checkbox" ref={register} name={name} className={styles.checkbox__input} />
        <span className={styles.checkbox__label}>{children}</span>
      </label>
      {error?.message && (
        <Block top={2}>
          <div className="body-text color--red">↑ {error.message}</div>
        </Block>
      )}
    </>
  );
};

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  error: PropTypes.any,
  register: PropTypes.func.isRequired
};

export default Checkbox;
